const { Manager } = require("socket.io-client");
const cloneDeep = require("lodash.clonedeep");
import { getAuthHeaders } from "./utils/http";
const tag = "[NxVetSocket]";

class ChangeEmitter {
  _createCb = undefined;
  _updateCb = undefined;
  _deleteCb = undefined;
  _startCb = undefined;
  _socket = undefined;
  _socketID = undefined;
  _collection = undefined;
  _condition = undefined;
  _options = undefined;
  _cancelCb = undefined;
  _watchTicket = undefined;
  constructor(collection, condition = {}, options = {}) {
    if (!options) {
      throw "Please specify focus collections";
    }
    console.log(
      tag,
      `create eventEmitter for '${collection}', condition:${JSON.stringify(
        condition
      )}, options:${JSON.stringify(options)}`
    );
    this._collection = collection;
    this._condition = condition;
    this._options = options;
    return this;
  }
  setCancelListener(cb) {
    this._cancelCb = cb;
  }

  onCreate(cb) {
    this._createCb = cb;
    return this;
  }
  onUpdate(cb) {
    this._updateCb = cb;
    return this;
  }
  onDelete(cb) {
    this._deleteCb = cb;
    return this;
  }
  onStart(cb) {
    this._startCb = cb;
    return this;
  }
  isActive() {
    return this._socket && this._socket.id;
  }
  watchChange(socket, cb) {
    // console.log(tag, "watchChange");

    if (this._socket && socket.id === this._socketID) {
      return;
    }
    this._socket = socket;
    this._socketID = socket.id;
    console.log(
      tag,
      `emit watchChange for '${this._collection}' with sockect [${this._socket.id}]`
    );
    let _this = this;
    socket.emit(
      "watchChange",
      this._collection,
      this._condition,
      this._options,
      (res) => {
        console.log(tag, res); // ok
        _this._watchTicket = res.watchTicket;
        cb(res.watchTicket);
      }
    );
  }
  cancel() {
    console.log(tag, `cancel listener with watchTicket: ${this._watchTicket}`);
    if (this._socket) {
      this._socket.emit("cancelWatch", this._watchTicket, (res) => {
        console.log(tag, res); // ok
      });
    }

    if (this._cancelCb && typeof this._cancelCb === "function") {
      this._cancelCb(this._watchTicket);
    }
  }
}

class SDK {
  // instance fields
  apiEndpoint = undefined;
  socket = undefined;
  changeEmitterMap = {};
  changeEmitterQueue = [];
  connectionCb = [];

  constructor(options) {
    if (!options) {
      throw "Please specify constructor options";
    }

    this.apiEndpoint = SDK.findProperApiEndpoint(options.hostname);

    console.log("NxVetSocketSDK initialized");
  }

  /**
   * Find the proper api endpoint based on hostname
   */
  static findProperApiEndpoint(hostname) {
    if (hostname) {
      switch (hostname) {
        // development site
        case "dev.nxvet.io":
        case "node3.nxvet.io":
          return "https://dev.nxvet.io";
        // production site
        case "nxvet.io":
        case "www.nxvet.io":
        case "node4.nxvet.io":
          return "https://ws-s1.nxvet.io";
        // production s2 site
        case "s2.nxvet.io":
        case "node5.nxvet.io":
          return "https://s2.nxvet.io";
        // production s3 site
        case "s3.nxvet.io":
        case "node6.nxvet.io":
          return "https://ws-s3.nxvet.io";
        // production s4 site
        case "s4.nxvet.io":
        case "node7.nxvet.io":
          return "https://s4.nxvet.io";
        // production s4m site
        case "s4m.nxvet.io":
          return "https://s4m.nxvet.io";
        // production s5 site
        case "s5.nxvet.io":
          return "https://ws-s5.nxvet.io";
        // production s6 site
        case "s6.nxvet.io":
          return "https://ws-s6.nxvet.io";
        // production s7 site
        case "s7.nxvet.io":
          return "https://ws-s7.nxvet.io";
        // production s99 site
        case "s99.nxvet.io":
          return "https://ws-s99.nxvet.io";
      }
      if (hostname.indexOf("192.168") != -1) return `http://${hostname}:6500`;
    }

    // all the other cases
    return "http://127.0.0.1:6500";
  }

  connect() {
    console.log(tag, "start socket connect");
    const manager = new Manager(`${this.apiEndpoint}`, {
      query: {
        clinic: localStorage.getItem("CLINIC"),
      },
    });

    if (this.socket) {
      this.disconnect();
    }

    const namespace = `/socket/clinic/${localStorage.getItem("CLINIC")}/change`;

    this.socket = manager.socket(namespace, {
      auth: {
        token: getAuthHeaders().headers.Authorization,
      },
    }); // change namespace

    let _this = this;
    this.socket.on("connect", () => {
      console.log(tag, `connect to ${namespace} success ${_this.socket.id}`);
      console.log(
        tag,
        "changeEmitterQueue size:",
        this.changeEmitterQueue.length
      );
      while (_this.changeEmitterQueue.length) {
        const ce = _this.changeEmitterQueue.shift();
        ce.watchChange(_this.socket, (wt) => {
          _this.changeEmitterMap[wt] = ce;
        });
      }
      _this.connectionCb.forEach((cb) => {
        cb("connect");
      });
    });

    this.socket.on("start", (wt, data) => {
      // console.log(
      //   tag,
      //   `receive start change for ticket '${wt}' with data ${JSON.stringify(
      //     data
      //   )}`
      // );

      if (_this.changeEmitterMap[wt]._startCb) {
        _this.changeEmitterMap[wt]._startCb(data);
      }
    });
    this.socket.on("update", (wt, data) => {
      // console.log(
      //   tag,
      //   `receive update change for ticket '${wt}' with data ${JSON.stringify(
      //     data
      //   )}`
      // );
      if (_this.changeEmitterMap[wt]._updateCb) {
        _this.changeEmitterMap[wt]._updateCb(data);
      }
    });
    this.socket.on("create", (wt, data) => {
      // console.log(
      //   tag,
      //   `receive create change for ticket '${wt}' with data ${JSON.stringify(
      //     data
      //   )}`
      // );
      if (_this.changeEmitterMap[wt]._createCb) {
        _this.changeEmitterMap[wt]._createCb(data);
      }
    });
    this.socket.on("delete", (wt, data) => {
      // console.log(
      //   tag,
      //   `receive delete change for ticket '${wt}' with data ${JSON.stringify(
      //     data
      //   )}`
      // );
      if (_this.changeEmitterMap[wt]._deleteCb) {
        _this.changeEmitterMap[wt]._deleteCb(data);
      }
    });

    this.socket.on("disconnect", (reason) => {
      console.error(tag, "disconnect", reason);

      //轉換至waiting queue等待重新連線後，重新申請watchTicket
      this.changeEmitterQueue = this.changeEmitterQueue.concat(
        Object.keys(this.changeEmitterMap).map(
          (wt) => this.changeEmitterMap[wt]
        )
      );
      this.changeEmitterMap = {};
      console.log(
        tag,
        "changeEmitterQueue size",
        this.changeEmitterQueue.length
      );

      _this.connectionCb.forEach((cb) => {
        cb("disconnect");
      });
    });
    this.socket.on("connect_error", (error) => {
      console.error(tag, "connect_error", error);

      _this.connectionCb.forEach((cb) => {
        cb("connect_error", error);
      });
    });
  }
  disconnect() {
    console.log(tag, "manually close socket connect");

    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    this.changeEmitterMap = {};
    this.changeEmitterQueue = [];
  }
  drop() {
    console.log(tag, "drop all cache emitter");
    this.changeEmitterMap = {};
    this.changeEmitterQueue = [];
  }
  addConnectionListener(cb) {
    if (typeof cb === "function") {
      this.connectionCb.push(cb);
    }
  }
  removeConnectionListener(cb) {
    const index = this.connectionCb.indexOf(cb);
    if (index > -1) {
      this.connectionCb.splice(index, 1);
    }
  }
  isConnect() {
    return this.socket && this.socket.id;
  }

  checkConnect() {
    return new Promise((resolve) => {
      if (this.socket && this.socket.id) {
        this.socket.emit("checkConnect", this.socket.id, (res) => {
          // console.log(tag, res);
          resolve(res);
        });
      } else {
        resolve(false);
      }
    });
  }

  addDocChangeListener(collection, condition = {}, options = {}) {
    let _this = this;
    let changeEmitter = new ChangeEmitter(collection, condition, options);
    changeEmitter.setCancelListener((wt) => {
      console.log(tag, "trigger cancelListener,", wt);
      delete _this.changeEmitterMap[wt];
    });

    if (this.socket && this.socket.id) {
      changeEmitter.watchChange(this.socket, (wt) => {
        _this.changeEmitterMap[wt] = changeEmitter;
      });
    } else {
      console.log(
        tag,
        `socket not ready push '${collection}' to emitter queue`
      );
      this.changeEmitterQueue.push(changeEmitter);
    }
    return changeEmitter;
  }
}

export default SDK;
